"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "routePathContext", {
  enumerable: true,
  get: function get() {
    return _routePathContext["default"];
  }
});
exports.useRoutePath = void 0;

var _react = require("react");

var _routePathContext = _interopRequireDefault(require("../context/routePathContext"));

var _utils = require("../utils");

var useRoutePath = function useRoutePath(routePath) {
  var routePathContextValue = (0, _react.useContext)(_routePathContext["default"]); // If we are in a routePathContext, use it always

  if (routePathContextValue) {
    return routePathContextValue;
  } // Clean the path


  return (0, _utils.getRoutePath)(routePath);
};

exports.useRoutePath = useRoutePath;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9icm93c2VyL2hvb2tzL3VzZVJvdXRlUGF0aC5qcyJdLCJuYW1lcyI6WyJ1c2VSb3V0ZVBhdGgiLCJyb3V0ZVBhdGgiLCJyb3V0ZVBhdGhDb250ZXh0VmFsdWUiLCJyb3V0ZVBhdGhDb250ZXh0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFDQTs7QUFJTyxJQUFNQSxZQUFZLEdBQUcsU0FBZkEsWUFBZSxDQUFBQyxTQUFTLEVBQUk7QUFDdkMsTUFBTUMscUJBQXFCLEdBQUcsdUJBQVdDLDRCQUFYLENBQTlCLENBRHVDLENBR3ZDOztBQUNBLE1BQUlELHFCQUFKLEVBQTJCO0FBQ3pCLFdBQU9BLHFCQUFQO0FBQ0QsR0FOc0MsQ0FRdkM7OztBQUNBLFNBQU8seUJBQWFELFNBQWIsQ0FBUDtBQUNELENBVk0iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VDb250ZXh0IH0gZnJvbSAncmVhY3QnXHJcbmltcG9ydCByb3V0ZVBhdGhDb250ZXh0IGZyb20gJy4uL2NvbnRleHQvcm91dGVQYXRoQ29udGV4dCdcclxuaW1wb3J0IHsgZ2V0Um91dGVQYXRoIH0gZnJvbSAnLi4vdXRpbHMnXHJcblxyXG5leHBvcnQgeyByb3V0ZVBhdGhDb250ZXh0IH1cclxuXHJcbmV4cG9ydCBjb25zdCB1c2VSb3V0ZVBhdGggPSByb3V0ZVBhdGggPT4ge1xyXG4gIGNvbnN0IHJvdXRlUGF0aENvbnRleHRWYWx1ZSA9IHVzZUNvbnRleHQocm91dGVQYXRoQ29udGV4dClcclxuXHJcbiAgLy8gSWYgd2UgYXJlIGluIGEgcm91dGVQYXRoQ29udGV4dCwgdXNlIGl0IGFsd2F5c1xyXG4gIGlmIChyb3V0ZVBhdGhDb250ZXh0VmFsdWUpIHtcclxuICAgIHJldHVybiByb3V0ZVBhdGhDb250ZXh0VmFsdWVcclxuICB9XHJcblxyXG4gIC8vIENsZWFuIHRoZSBwYXRoXHJcbiAgcmV0dXJuIGdldFJvdXRlUGF0aChyb3V0ZVBhdGgpXHJcbn1cclxuIl19